
import templateComponent from '@/app-template/lib/components/ImageModal.vue';
import { defineComponent } from '@vue/runtime-core';

export default defineComponent({
  name: 'ImageModal',
  components: { templateComponent },
});
